import { getOpxHostApi } from 'owa-opx/lib/getOpxHostApi';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import type { LiteScenarioData } from './types/LiteScenarioData';
import type { MiniHostAppDetail } from './types/MiniHostAppDetail';

let miniHostAppDetails: MiniHostAppDetail = null;

const SCENARIO_DATA_KEYS: Array<keyof MiniHostAppDetail> = [
    'appVersionName',
    'appVersionCode',
    'androidVersion',
    'deviceModel',
    'diskUsage',
    'themeMode',
    'hostAppFeatureFlags',
    'isNotificationPermissionDenied',
    'notificationSettings',
    'accounts',
    'culture',
];

/**
 * Returns the details of the app hosting mini-owa
 * E.g. Outlook Lite
 */
export const getMiniHostAppDetail = (): MiniHostAppDetail => {
    if (isMiniHostAppFeatureEnabled('native')) {
        if (!miniHostAppDetails) {
            throw new Error('Host app details not set');
        }

        return miniHostAppDetails;
    }

    return null;
};

export const setMiniHostAppDetail = async (): Promise<void> => {
    const opxHostApi = getOpxHostApi();
    if (!opxHostApi) {
        throw new Error('OPX host API not found');
    }

    const [scenarioData, isDarkTheme] = await Promise.all([
        opxHostApi.getScenarioData<LiteScenarioData>(),
        opxHostApi.isDarkTheme(),
    ]);

    miniHostAppDetails = {} as MiniHostAppDetail;
    miniHostAppDetails.isDarkTheme = isDarkTheme;

    // initialize the host-app details with the scenario-data
    SCENARIO_DATA_KEYS.forEach(key => {
        if (scenarioData.hasOwnProperty(key)) {
            (miniHostAppDetails[key] as MiniHostAppDetail[typeof key]) = scenarioData[key];
        }
    });
};

export const updatePartialMiniHostAppDetail = (
    partialHostAppDetail: Partial<MiniHostAppDetail>
): void => {
    const currentHostAppDetail = getMiniHostAppDetail();

    if (!partialHostAppDetail || !currentHostAppDetail) {
        return;
    }

    Object.assign(currentHostAppDetail, partialHostAppDetail);
};
